<template>
  <div>
    <section class="feature-area section-padding2 toubugaodu"
      style=" height: 400px; background: url('../static/assets/images/bannerc.jpg') no-repeat;background-size: 100% auto;">
      <div class="container">
        <div class="row toubugaoduzt" style="height: 400px; line-height: 400px;color: #ffffff;font-size: 45px;">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <p style=" font-style: initial; ">关于我们</p>
            </div>
          </div>
        </div>

      </div>
      <div class="about_tab">
        <router-link class="about_tab_jj" to="/about" @click.native="reloadPage"
          style="background: #0473db;color: #ffffff;">企业简介</router-link>
        <router-link class="about_tab_wh" to="/wenhua" @click.native="reloadPage">企业文化</router-link>
        <router-link class="about_tab_jg" to="/jiagou" @click.native="reloadPage">企业架构</router-link>
        <router-link class="about_tab_zr" to="/zeren" @click.native="reloadPage">认证体系</router-link>
        <router-link class="about_tab_sm" to="/shengming" @click.native="reloadPage">版权声明</router-link>
      </div>
    </section>
    <section class="feature-area section-padding2 about_section1">
      <div class="container about912" style="padding-top: 100px;">
        <div class="row" style="height: 130px;">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>烟台拿度智能科技有限公司</h2>
              <p style="line-height: 50px;font-size: 16px;">专注于工业自动化测控领域的应用产品开发与技术服务</p>
            </div>
          </div>
        </div>
        <div class="row" style="padding: 0px 8%; line-height: 36px;font-size: 16px;">
          <p v-html="aboutinfo.content"></p>
        </div>
        <div style="width: 80%;margin-left: 10%;" class="buxianshi">
          <div style="width: 100%; height: 400px;padding-top: 50px;">
            <div style="float: left;width: 50%;">
              <img src="/static/assets/images/aboutds.png" class="">
            </div>
            <div style="float: left;width: 50%;">
              <p style="font-size: 22px;font-weight: bold;"><i style="color: #e40230;"> ♥ </i> 核心价值观</p>
              <p>协作 、责任 、进步</p>
              <p style="font-size: 22px;font-weight: bold;"><i style="color: #e40230;"> ♥ </i> 企业愿景</p>
              <p>专注于工业自动化测控领域的应用产品开发与技术服务</p>
              <p style="font-size: 22px;font-weight: bold;"><i style="color: #e40230;"> ♥ </i> 不朽使命</p>
              <p>我们追求在瞬息万变的高科技测控世界里，创造不朽的品质和价值。不朽精神将会以无限的可能传递和延申，为您，也为我们自己。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Area End -->


    <!-- Team Area Starts -->
    <section class="team-area section-padding2">
      <div style="width: 100%;">

        <div class="advantage_num">
          <ul>
            <li class="wow fadeInLeft animated" style="visibility: visible; animation-name: fadeInLeft;">
              <div class="img_box"><img src="/static/assets/images/advantage01.jpg" alt=""></div>
              <div class="text_box">
                <span><em class="counter">6</em><i>大</i></span>
                <p>主要业务板块，<br>
                  磁致伸缩位移传感器、激光传感器</p>
              </div>
            </li>
            <li class="wow fadeInLeft animated" style="visibility: visible; animation-name: fadeInLeft;">
              <div class="img_box"><img src="/static/assets/images/advantage02.jpg" alt=""></div>
              <div class="text_box">
                <span><em class="counter">10</em><i>年</i></span>
                <p>十年以上的行业经验，<br>
                  强大的传感器研发、设计和测试工程师团队</p>
              </div>
            </li>
            <li class="wow fadeInLeft animated" style="visibility: visible; animation-name: fadeInLeft;">
              <div class="img_box"><img src="/static/assets/images/advantage03.jpg" alt=""></div>
              <div class="text_box">
                <span><em class="counter">60</em><i>种</i></span>
                <p>位移传感器产品，<br>
                  技术上追求“度”，做事上立本于“度”</p>
              </div>
            </li>

          </ul>
        </div>

      </div>
    </section>
    <!-- Team Area End -->

  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {
    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/21', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.aboutinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
  },
  methods: {
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 20) {
      return dateStr.substring(0, length);
    },


  }
};
</script>



// WEBPACK FOOTER //
// About.vue?8670b7fa